import { isFunction } from "@vue/shared";

export enum StatActionEnum {
    /**
     * 点击埋点
     */
    CLICK = 'click',

    /**
     * 展示埋点
     */
    VIEW = 'view',
} 

export enum PayOrderEnum {
    /**
     * 支付成功
     */
    SUCCESS = 1,

    /**
     * 支付失败
     */
    FIALED = 2,

    /**
     * 取消支付
     */
    CANCEL = 3,
}

/**
 * 支付统一参数
 */
export interface PayModel {
    /**
     * 商品id
     */
    shopId: number,
    /**
     * 支付方式
     * 饭橘： 1微信 2支付宝 3苹果
     */
    payMethod: number,
    /**
     * 页面入口
     * 自行确认
     */
    enterAction?: string,
    /**
     * 支付金额
     * 喵喵需要，饭橘不需要
     */
    price?: number;

    /**
     * 这个type是喵喵需要的
     */
    type?: number;

    /**
     * 商品id
     */
    productId?: string;
}

export interface StatModel {
    pageKey: string;
    target: string;
    action: StatActionEnum | PayOrderEnum;
    actionParams?: string;
    pageParams?: string;
}

export interface SharedModel {
    targeturl: string;
    title: string;
    desc: string;
    imgUrl: string;
}

interface PayOrderModelMethod {
    success(): boolean;
}

interface PayOrderModel extends PayOrderModelMethod {
    status: PayOrderEnum;
    message?: string;
}

export enum SdkUserPlatform {
    /**
     * IOS表识符
     */
    Ios = 0,
    /**
     * 安卓标识符
     */
    Android = 1,
    /**
     * 鸿蒙标识符
     */
    Harmony = 2,
}

/**
 * 客户端用户信息model
 */
export interface SdkUserModel {
    /**
     * 用户id
     */
    id: string;
    /**
     * 部分项目存在长id情况，这个是长id
     */
    hashId: string;
    /**
     * 活动id
     */
    activityId: string;
    /**
     * 用户昵称
     */
    name: string;
    /**
     * 用户头像
     */
    cover: string;
    /**
     * 平台
     */
    platform: SdkUserPlatform;
    /**
     * 设备类型
     */
    deviceModel: string;
    /**
     * 制造商
     */
    manufacturer: string;
    /**
     * 应用版本
     */
    app_version: string;
    /**
     * 设备版本
     */
    deviceVersion: string;
    /**
     * IOS设备id(idfa)
     */
    idfa: string;
    /**
     * 安卓设备id(oaid)
     */
    oaid: string;
    /**
     * 用户token,服务器解密
     * 中台交互token,所有数据通过这个token上报服务器
     */
    token: string;
}

interface IncentiveVideoModel {
    /**
     * 页面标识
     */
    page: string;

    /**
     * 广告位置
     */
    location: string;

    /**
     * 失败次数缓存
     */
    failCountKey: string;
}

/**
 * 激励视频逻辑处理
 */
export interface IncentiveVideoResult {
    /**
     * 是否看完广告（2.4.0）版本添加
     */
    isWatchVideo: boolean;

    /**
     * 是否可以领奖
     */
    isAcquirePrize: boolean;

    /**
     * 广告信息
     */
    msg: string;

    /**
     * 客户端成功还是失败
     */
    clientIsSuccess: boolean;
}

export enum StatEventEnum {
    view = 'ui_view',
    click = 'ui_click'
}

export interface ClientSdk {
    /**
     * 获取SDK用户信息
     * @SdkUserModel {
     *   id: 用户id string
     *   name: 用户昵称 string
     *   activityId: 活动id string
     * }
     */
    loadUser: () => Promise<SdkUserModel>;

    /**
     * 调起sdk分享
     * @returns 
     */
    shared: (option: SharedModel) => Promise<void>;

    /**
     * 发起埋点
     * @param model 
     * @returns 
     */
    stat: (model: StatModel) => Promise<void>;

    /**
     * 发起支付
     * @returns 
     */
    payOrder: (model: PayModel) => Promise<PayOrderModel>;

    /**
     * 退出页面
     * @returns 
     */
    backWeb: () => Promise<void>;
    
    /**
     * 联系客服
     * @returns 
     */
    toContactWX: (url: string) => Promise<void>;

    /**
     * 查看激励视频
     * @param model 
     */
    incentiveVideo(model: IncentiveVideoModel): Promise<IncentiveVideoResult>;

    /**
     * 客户端新埋点逻辑（针对数数）
     * @returns 
     */
    event<R>(eventId: StatEventEnum, pageParams?: R): void;

    /**
     * 喵喵专用(刷新产品信息)
     * @returns 
     */
    refreshProduct(): void;
}

type PartialFunction<T> = {
    [K in keyof T]?: T[K] extends (...args: any[]) => any ? T[K] : never
};

export const createSdkFactoryParam = (action: string, data = {}) => ({
    action,
    data: JSON.stringify(data),
});




/**
 * 创建通信方法
 * @param sdkData 
 * @param callback 
 */
export const createSdkFactory = (handler: (data: string) => void, sdkData: {
    action: string;
    data?: object;
} | null = null, callback: PartialFunction<SdkGlobal> = {}) => {
    const globalWindow = (window as SdkGlobal);
    Object.keys(callback).forEach(key => {
        const globalKey = key as keyof SdkGlobal;
        globalWindow._messages = globalWindow._messages || {};
        if (!globalWindow._messages[globalKey]) {
            globalWindow._messages[key] = [];
            (globalWindow[globalKey] as any) = (...args: any[]) => {
                let call: any;
                // 每次添加进来，执行完成后退出去
                while (call = globalWindow._messages[globalKey].shift()) {
                    call(...args);
                }
            };
        }
        // 每个方法执行时的执行时机处理，两个方法同时调用时，最终的回调需要区分方法
        globalWindow._messages[globalKey].push(callback[globalKey] as any);
    });
    
    try {
        handler(JSON.stringify(sdkData));
    } catch(e) {
        let isFirst = false
        Object.keys(callback).forEach(key => {
            if (isFirst) return;
            isFirst = true;
            const globalKey = key as keyof SdkGlobal;
            globalWindow._messages = globalWindow._messages || {};
            globalWindow._messages[key] = [];
            if (callback[globalKey] && isFunction(callback[globalKey])) {
                (callback[globalKey] as any)(`{ "data": {} }`);
            }
        });
        console.warn(`非客户端环境，${sdkData?.action} [${sdkData?.data}]调用失败`);
    }
}

export function getStatusBarHeight() {
    let statusBarHeight = 0;
    if (window.visualViewport) {
      statusBarHeight = window.visualViewport.offsetTop * (window.devicePixelRatio || 2);
    } else if (window.screen && window.matchMedia('(display-cutout: constant)').matches) {
      const devicePixelRatio = window.devicePixelRatio;
      statusBarHeight = Math.round(24 * devicePixelRatio);
    }
    return statusBarHeight;
}

let requestId = 1;
export function getRequestId() {
    return ++requestId;
}